import OverlayWrapper from './OverlayWrapper'
import '../styles/PathSegmentMeasurementOverlay.css'
import { useMainStore } from '@/stores/main'

import { v4 as uuidv4 } from 'uuid'
import { defaultsDeep } from 'lodash'
import { markRaw } from 'vue'

const cmp = markRaw({
  template: `
  <span>{{measurement}} {{suffix}}</span>
  `,
  props: {
    'x': Number,
    'y': Number,
    'overlay': Object,
    'options': {
      type: Object,
      default: {}
    },
    'text': {
      type: String,
      default: ''
    },
    'visible': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    shape() {
      const mainStore = useMainStore();
      return mainStore.shapesWithConversions.find(s => s.indexID == this.options.shapeIndexID);
    },
    measurement() {
      if (this.shape) {
        return this.shape.convertedSegmentLengths[this.options.segmentIdx];
      }
    },
    suffix() {
      if (this.shape) {
        return this.shape.distanceSuffix;
      }
    }
  },
  watch: {    
    visible: {
      handler: function(visible) {
        if (visible) {
          return;
        }        
      }      
    }
  },
  methods: {
    getUUID() {
      return uuidv4();
    },
    handleBehavior(btn, eventName, e) {
      this.$emit(`overlay-event`, eventName, btn, e);
      return false;
    }
  },
  mounted() {    
    
  },
  data() {
    return {
      uuid: uuidv4()      
    }
  },
  name: 'TextOverlay'
})

function Overlay(map, config = {}) {
  const defaults = {
    options: {
      prefix: '',
      iconsOnly: true
    },
    classes: []
  };

  config = defaultsDeep(config, defaults);
  // config = Object.assign(defaults, config);
  if (config.options.prefix) config.options.prefix += '-';
  
  OverlayWrapper.call(this, map, config);
  this.cmp = cmp;  
}

Overlay.prototype = Object.create(OverlayWrapper.prototype);
export default Overlay;